import { cpfDigitsOnly, phoneDigitsOnly } from "./masks";

/** Customer (pessoa física) field ids → corretor row ids for parceria captantes/intermediadores. */
export const PESSOA_FISICA_TO_CORRETOR = {
  NOME_PESSOA_FISICA: "NOME_CORRETOR",
  NACIONALIDADE_PESSOA_FISICA: "NACIONALIDADE_CORRETOR",
  CPF_PESSOA_FISICA: "CPF_CORRETOR",
  RG_PESSOA_FISICA: "RG_CORRETOR",
  RUA_ENDERECO_PESSOA_FISICA: "RUA_ENDERECO_CORRETOR",
  N_ENDERECO_PESSOA_FISICA: "N_ENDERECO_CORRETOR",
  BAIRRO_ENDERECO_PESSOA_FISICA: "BAIRRO_ENDERECO_CORRETOR",
  MUN_ENDERECO_PESSOA_FISICA: "MUN_ENDERECO_CORRETOR",
  CEP_PESSOA_FISICA: "CEP_CORRETOR",
  EMAIL_PESSOA_FISICA: "EMAIL_CORRETOR",
  TEL_PESSOA_FISICA: "TEL_CORRETOR",
};

function sectionUsesCorretorFields(sectionFields) {
  return sectionFields?.some((f) => f.id === "NOME_CORRETOR");
}

function applyPessoaFisicaToCorretorMapping(source) {
  const out = { ...source };
  Object.entries(PESSOA_FISICA_TO_CORRETOR).forEach(([pfKey, corKey]) => {
    if (out[corKey] == null || out[corKey] === "") {
      const fromPf = source[pfKey];
      if (fromPf != null && fromPf !== "") {
        out[corKey] = fromPf;
      }
    }
  });
  return out;
}

/**
 * @param {object[]} schema - document formSchema (sections)
 * @param {string} groupKey - e.g. "vendedores"
 */
export function getRepeatableSectionFields(schema, groupKey) {
  if (!Array.isArray(schema)) return [];
  const section = schema.find(
    (s) => s.repeatable && s.groupKey === groupKey
  );
  return section?.fields ?? [];
}

/**
 * Maps a saved customer (API) into one repeatable row object for pessoa física sections
 * (flat NOME_CONJUGE… fields, same shape as DynamicContractForm rows).
 */
export function mapCustomerRecordToRepeatableRow(customer, sectionFields) {
  if (!sectionFields?.length) return {};

  const c = customer && typeof customer === "object" ? customer : {};
  const conj = c.conjuge && typeof c.conjuge === "object" ? c.conjuge : {};

  const flat = {
    ...c,
    NOME_CONJUGE: c.NOME_CONJUGE ?? conj.NOME_CONJUGE ?? "",
    CPF_CONJUGE: c.CPF_CONJUGE ?? conj.CPF_CONJUGE ?? "",
    RG_CONJUGE: c.RG_CONJUGE ?? conj.RG_CONJUGE ?? "",
    NACIONALIDADE_CONJUGE:
      c.NACIONALIDADE_CONJUGE ?? conj.NACIONALIDADE_CONJUGE ?? "",
    PROFISSAO_CONJUGE: c.PROFISSAO_CONJUGE ?? conj.PROFISSAO_CONJUGE ?? "",
    EMAIL_CONJUGE: c.EMAIL_CONJUGE ?? conj.EMAIL_CONJUGE ?? "",
  };

  const { conjuge: _drop, ...rest } = flat;

  const mappedRest = sectionUsesCorretorFields(sectionFields)
    ? applyPessoaFisicaToCorretorMapping(rest)
    : rest;

  const row = {};
  for (const field of sectionFields) {
    const id = field.id;
    const v = mappedRest[id];
    let str = v != null && v !== undefined ? String(v) : "";
    if (field.mask === "cpf" || id.startsWith("CPF_")) {
      str = cpfDigitsOnly(str);
    } else if (
      field.mask === "phone" ||
      id.startsWith("TEL_") ||
      id === "CELULAR_IMOBILIARIA"
    ) {
      str = phoneDigitsOnly(str);
    }
    row[id] = str;
  }

  const estado = row.ESTADO_CIVIL_PESSOA_FISICA;
  if (estado !== "casado") {
    sectionFields.forEach((f) => {
      if (
        f.showWhen?.field === "ESTADO_CIVIL_PESSOA_FISICA" &&
        f.showWhen?.value === "casado"
      ) {
        row[f.id] = "";
      }
    });
  }

  return row;
}
